var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"staff-list-page"},[_c('page-title',[_vm._v(_vm._s(_vm.$t('employees.list')))]),_vm._v(" "),_c('user-list',{attrs:{"pageBaseUrl":"/users/list"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }